// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function betweenSelectedDaysClass(className, startDay, endDay, stage, hoveredDay, day) {
  switch (stage) {
    case /* Default */0 :
        if (startDay !== undefined && endDay !== undefined) {
          return Cn.on(className, DateTime.compare(day, Caml_option.valFromOption(startDay)) > 0 && DateTime.compare(day, Caml_option.valFromOption(endDay)) < 0);
        } else {
          return "";
        }
    case /* StartDaySelecting */1 :
        if (startDay !== undefined && hoveredDay === undefined) {
          if (endDay !== undefined) {
            return Cn.on(className, DateTime.compare(day, Caml_option.valFromOption(startDay)) > 0 && DateTime.compare(day, Caml_option.valFromOption(endDay)) < 0);
          } else {
            return "";
          }
        }
        if (hoveredDay !== undefined && endDay !== undefined) {
          return Cn.on(className, DateTime.compare(day, Caml_option.valFromOption(hoveredDay)) > 0 && DateTime.compare(day, Caml_option.valFromOption(endDay)) < 0);
        } else {
          return "";
        }
    case /* EndDaySelecting */2 :
        if (startDay === undefined) {
          return "";
        }
        const startDay$1 = Caml_option.valFromOption(startDay);
        if (hoveredDay !== undefined) {
          return Cn.on(className, DateTime.compare(day, startDay$1) > 0 && DateTime.compare(day, Caml_option.valFromOption(hoveredDay)) < 0);
        } else if (endDay !== undefined) {
          return Cn.on(className, DateTime.compare(day, startDay$1) > 0 && DateTime.compare(day, Caml_option.valFromOption(endDay)) < 0);
        } else {
          return "";
        }
    case /* StartMonthSelecting */3 :
    case /* EndMonthSelecting */4 :
        return "";
    
  }
}

const Utils = {
  betweenSelectedDaysClass: betweenSelectedDaysClass
};

const container = "grid grid-cols-7x40px gap-px bg-white-12 rounded border border-solid border-white-12";

const animate = "animate-fadeScaleIn";

const cell = "w-10 h-10 text-center bg-black flex items-center justify-center hover:bg-secondary cursor-pointer";

const cell__empty = "w-10 h-10 bg-black";

const cell__selected = "bg-secondary";

const cell__today = "bg-success";

const cell__disabled = "pointer-events-none";

const Styles = {
  container: container,
  animate: animate,
  cell: cell,
  cell__empty: cell__empty,
  cell__selected: cell__selected,
  cell__today: cell__today,
  cell__disabled: cell__disabled
};

function getDayNames(param) {
  const dayNames = {
    hd: "Пн",
    tl: {
      hd: "Вт",
      tl: {
        hd: "Ср",
        tl: {
          hd: "Чт",
          tl: {
            hd: "Пт",
            tl: {
              hd: "Сб",
              tl: {
                hd: "Вс",
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  };
  let dayNameDivs = /* [] */0;
  for(let i = 1 ,i_finish = Belt__Belt_List.length(dayNames); i <= i_finish; ++i){
    const day = Belt__Belt_List.get(dayNames, i - 1 | 0);
    if (day !== undefined) {
      const Key = "dayname-" + String(i);
      const dayNameDiv = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-gray-medium",
                  children: day
                }),
            className: cell
          }, Key);
      dayNameDivs = Stdlib.$at(dayNameDivs, {
            hd: dayNameDiv,
            tl: /* [] */0
          });
    }
    
  }
  return dayNameDivs;
}

function getDays(month, year, tillCurrentDate, displayCurrentDate, monthEndDay, startWeekDay, selectedStartDay, selectedEndDay, hoveredDay, setHoveredDay, stage, onDaySelected, param) {
  let divs = /* [] */0;
  let i = 1;
  while(i < startWeekDay) {
    const i$1 = i;
    const Key = "day-empty" + String(i$1);
    const div = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-white",
                children: null
              }),
          className: cell__empty
        }, Key);
    divs = Stdlib.$at(divs, {
          hd: div,
          tl: /* [] */0
        });
    i = i + 1 | 0;
  };
  i = 1;
  while(i <= monthEndDay) {
    const i$2 = i;
    const currentDt = DateTime.local(year, month, i$2, undefined, undefined, undefined, undefined, undefined);
    const Key$1 = "day-" + String(i$2);
    const div$1 = JsxRuntime.jsx("div", {
          children: tillCurrentDate ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: Cn.fromList({
                        hd: DateTime.compare(currentDt, DateTime.startOf("day", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))) > 0 ? "text-gray-medium" : "text-white",
                        tl: /* [] */0
                      }),
                  children: String(i$2)
                }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-white",
                  children: String(i$2)
                }),
          className: Cn.fromList({
                hd: cell,
                tl: {
                  hd: Cn.on(displayCurrentDate ? cell__today : "", DateTime.compare(DateTime.startOf("day", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)), currentDt) === 0),
                  tl: {
                    hd: Cn.on(tillCurrentDate ? cell__disabled : "", DateTime.compare(currentDt, DateTime.startOf("day", DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))) > 0),
                    tl: {
                      hd: Cn.mapSome(selectedStartDay, (function (selectedStartDay) {
                              return Cn.on(cell__selected, DateTime.compare(selectedStartDay, currentDt) === 0);
                            })),
                      tl: {
                        hd: Cn.mapSome(selectedEndDay, (function (selectedEndDay) {
                                return Cn.on(cell__selected, DateTime.compare(selectedEndDay, currentDt) === 0);
                              })),
                        tl: {
                          hd: betweenSelectedDaysClass("cell__between__selected", selectedStartDay, selectedEndDay, stage, hoveredDay, currentDt),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }),
          onClick: (function (param) {
              Curry._1(onDaySelected, currentDt);
            }),
          onMouseEnter: (function (param) {
              Curry._1(setHoveredDay, (function (param) {
                      return Caml_option.some(currentDt);
                    }));
            }),
          onMouseLeave: (function (param) {
              Curry._1(setHoveredDay, (function (param) {
                      
                    }));
            })
        }, Key$1);
    divs = Stdlib.$at(divs, {
          hd: div$1,
          tl: /* [] */0
        });
    i = i + 1 | 0;
  };
  const daysInLastRow = ((monthEndDay + startWeekDay | 0) - 1 | 0) % 7;
  if (daysInLastRow !== 0) {
    for(let i$3 = daysInLastRow + 1 | 0; i$3 <= 7; ++i$3){
      const Key$2 = "day-empty-after" + String(i$3);
      const div$2 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-white",
                  children: null
                }),
            className: cell__empty
          }, Key$2);
      divs = Stdlib.$at(divs, {
            hd: div$2,
            tl: /* [] */0
          });
    }
  }
  return divs;
}

function make(month) {
  return function (year) {
    return function (selectedStartDay) {
      return function (selectedEndDay) {
        return function (tillCurrentDateOpt) {
          const tillCurrentDate = tillCurrentDateOpt !== undefined ? tillCurrentDateOpt : false;
          return function (displayCurrentDateOpt) {
            const displayCurrentDate = displayCurrentDateOpt !== undefined ? displayCurrentDateOpt : true;
            return function (onDaySelectedOpt) {
              const onDaySelected = onDaySelectedOpt !== undefined ? onDaySelectedOpt : (function (param) {
                    
                  });
              return function (stageOpt) {
                const stage = stageOpt !== undefined ? stageOpt : /* Default */0;
                return function (transparentOpt) {
                  return function (ref_) {
                    const selectedStartDay$1 = Belt__Belt_Option.map(selectedStartDay, (function (param) {
                            return DateTime.startOf("day", param);
                          }));
                    const selectedEndDay$1 = Belt__Belt_Option.map(selectedEndDay, (function (param) {
                            return DateTime.startOf("day", param);
                          }));
                    const match = React.useState(function () {
                          return container;
                        });
                    const setContainerClasses = match[1];
                    React.useEffect((function () {
                            Curry._1(setContainerClasses, (function (param) {
                                    return Cn.fromList({
                                                hd: container,
                                                tl: {
                                                  hd: animate,
                                                  tl: /* [] */0
                                                }
                                              });
                                  }));
                            const animate$1 = setTimeout((function (param) {
                                    Curry._1(setContainerClasses, (function (param) {
                                            return container;
                                          }));
                                  }), 300);
                            return (function (param) {
                                      clearTimeout(animate$1);
                                    });
                          }), [
                          month,
                          year
                        ]);
                    let dt;
                    let exit = 0;
                    if (month !== undefined && year !== undefined) {
                      dt = DateTime.local(year, month, undefined, undefined, undefined, undefined, undefined, undefined);
                    } else {
                      exit = 1;
                    }
                    if (exit === 1) {
                      dt = DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                    }
                    const startWeekDay = DateTime.weekday(DateTime.startOf("month", dt));
                    const monthEndDay = DateTime.day(DateTime.endOf("month", dt));
                    const match$1 = React.useState(function () {
                          
                        });
                    let tmp = {
                      children: [
                        Belt__Belt_List.toArray(getDayNames(undefined)),
                        Belt__Belt_List.toArray(getDays(DateTime.month(dt), DateTime.year(dt), tillCurrentDate, displayCurrentDate, monthEndDay, startWeekDay, selectedStartDay$1, selectedEndDay$1, match$1[0], match$1[1], stage, onDaySelected, undefined))
                      ],
                      className: match[0]
                    };
                    const tmp$1 = Belt__Belt_Option.map((ref_ == null) ? undefined : Caml_option.some(ref_), (function (prim) {
                            return prim;
                          }));
                    if (tmp$1 !== undefined) {
                      tmp.ref = Caml_option.valFromOption(tmp$1);
                    }
                    return JsxRuntime.jsxs("div", tmp);
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

const make$1 = React.forwardRef(function (Props, ref_) {
      return Curry._8(make(Props.month)(Props.year), Props.selectedStartDay, Props.selectedEndDay, Props.tillCurrentDate, Props.displayCurrentDate, Props.onDaySelected, Props.stage, Props.transparent, ref_);
    });

export {
  Utils ,
  Styles ,
  getDayNames ,
  getDays ,
  make$1 as make,
}
/* make Not a pure module */
